module.exports = __webpack_public_path__ + "assets/28483115d767bef55fbfe789d68b3bd0.svg";